import React, { useRef } from 'react'
import { Button, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap'
import { MdDeleteOutline } from 'react-icons/md'
import UseAdminDeleteCoupon from '../../CustomHooks/Admin/UseAdminDeleteCoupon'
import UseAdminEditCoupon from '../../CustomHooks/Admin/UseAdminEditCoupon'
import { ToastContainer } from 'react-toastify';
import DeletePopUp from '../Layout/DeletePopUp'

const AdminCouponList = ({ item }) => {
    const [show, handleClose, handleShow, HandleDeleteCoupon] = UseAdminDeleteCoupon(item)
    const [isFormValid, editLoading, isPress, DateRef, ValidateCouponName, ValidateCouponValue, valiadteCouponDate, formatDate, Editshow, couponNameEdit, ChangeEditCouponName, couponDateEdit, ChangeEditCouponDate, couponDiscountValueEdit, ChangeEditCouponValue, handleEditClose, handleEditShow, HandleEditCoupon] = UseAdminEditCoupon(item)

    return (
        <div className="shadow my-3 p-3">
            <DeletePopUp show={show} handleDeleteItem={HandleDeleteCoupon} handleClose={handleClose} />
            <Modal show={Editshow} onHide={handleEditClose} centered>
                <Modal.Header className='bg-warning'>
                    <Modal.Title>Edit Coupon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Coupon Name</p>
                    <input
                        type="text"
                        className="form-control  d-block mb-3 px-3"
                        placeholder="Type Coupon Name"
                        value={couponNameEdit}
                        onChange={ChangeEditCouponName}
                        onBlur={ValidateCouponName}
                    />
                    <p>Expire Date</p>
                    <input
                        type="text"
                        className="form-control  d-block mb-3 px-3"
                        value={couponDateEdit}
                        onChange={ChangeEditCouponDate}
                        ref={DateRef}
                        onFocus={() => DateRef.current.type = "date"}
                        onBlur={valiadteCouponDate}
                        placeholder="Expire Date"

                    />
                    <p>Discount Value</p>
                    <InputGroup>
                        <Form.Control
                            type="number"
                            className="form-control  px-3"
                            placeholder="Discount Value"
                            value={couponDiscountValueEdit}
                            onChange={ChangeEditCouponValue}
                            onBlur={ValidateCouponValue} />
                        <InputGroup.Text>%</InputGroup.Text>
                    </InputGroup>

                </Modal.Body>
                <Modal.Footer className='d-flex flex-row justify-content-between align-items-center mt-2'>
                    {isPress ? editLoading ? <Spinner variant="warning" animation='border' /> : (<Button disabled={!isFormValid} onClick={HandleEditCoupon} className='text-black bg-warning px-4 py-2'>
                        Yes
                    </Button>) : (<Button disabled={!isFormValid} onClick={HandleEditCoupon} className='text-black bg-warning px-4 py-2'>
                        Yes
                    </Button>)}


                    <Button variant="info" onClick={handleEditClose} className='px-4 py-2'>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
            <div>
                <Row>
                    <Col sm="12" md="6">
                        <Col xs="12">
                            <p className='d-inline-block pe-2 fw-bold'>Coupon Name : </p>
                            <p className="d-inline-block">{item.name}</p>
                        </Col>
                        <Col xs="12">
                            <p className='d-inline-block pe-2 fw-bold'>Expire Date : </p>
                            <p className="d-inline-block"> {formatDate(item.expire)} </p>
                        </Col>
                        <Col xs="12" >
                            <p className='d-inline-block pe-2 fw-bold'>Discount Value : </p>
                            <p className='d-inline-block'> {item.discount} %
                            </p>
                        </Col>
                    </Col>
                    <Col sm="12" md="6">
                        <div className="d-flex p-2 justify-content-end">
                            <Button variant='warning' className="action-button mx-3" onClick={handleEditShow}> <MdDeleteOutline /> Edit </Button>
                            <Button variant='danger' className="action-button" onClick={handleShow}> <MdDeleteOutline /> Remove </Button>
                        </div>
                    </Col>
                </Row>
            </div>
            <ToastContainer limit={1} />
        </div>
    )
}

export default AdminCouponList
